import axios from 'axios/index';
import React, {Component} from 'react';
import {getCurrentUserId, getCurrentUserName, getJwt} from '../../services/authService';
import http from '../../services/httpService';
import NewCampaignSmsModal from '../modals/NewCampaignSmsModal';
import NewCampaignViberModal from '../modals/NewCampaignViberModal';
import AcquireSubscribers from './AcquireSubscribers';
import FacebookMessageCustomPost from './FacebookMessageCustomPost';
import FacebookSponsoredMessage from './FacebookSponsoredMessage';
import NoFeeds from "./feed/NoFeeds";
import ReactGA from "react-ga";
import {Route, Switch, Redirect, NavLink, Link} from 'react-router-dom';
import Sms from './Sms';
import ViberBusinessMessage from './Viber';
import WebPushCustomPost from './WebPushCustomPost';


const facebook_app_graph_url = process.env.REACT_APP_FB_URL;
const facebook_app_marketing_url = process.env.REACT_APP_FB_MARKETING_URL;

class Campaigns extends Component {
    state = {
        user: this.props.user,
        fb_user_id: '',
        // showTestFunctionalities: false,
        adAccounts: [],
        platforms_enabled: this.props.platforms_enabled,
        selectedAdAccount: '',
        selectedAdAccountName: '',
        extendedAccessToken: '',
        fbAdsManagementPermission: false,
        postDataPassed: '',
        richTextModalActive: false,
        viberModalActive: false,
        viberPlatformEnabled: false,
        fb_page_connected: false,
        webpush_platform_enabled: false,
        selectedSource: '',
        currentPlanLimitations: this.props.currentPlanLimitations,
        loader: false
    }
    setMultipost = () => {
        localStorage.setItem('multipost', 'true')

    };

    async componentDidMount() {
        //ReactGA.pageview(window.location.pathname + window.location.search);
        this.setState({loader: true})


        // const user_id = await getCurrentUserId();
        // const result = await http.get('api/user/' + user_id, { headers: { authorization: getJwt() } });
        // const result = await http.get('api/user_info', {headers: {authorization: getJwt()}});
        // const user = await result.data.data;
        const postDataPassed = this.props.location.state ? this.props.location.state.post : '';

        await this.setState({
            // user,
            postDataPassed
        })

        const {
            sources,
            //feeds_shared,
            selectedSource
        } = this.props;


        let platforms_enabled = this.props.platforms_enabled;
        //console.log('platforms_enabled: ', platforms_enabled)
        // console.log('platforms_enabled: ', platforms_enabled)
        let facebook_platform_enabled = platforms_enabled && platforms_enabled.indexOf("fb") > -1;
        let webpush_platform_enabled = platforms_enabled && platforms_enabled.indexOf("wp") > -1;
        let viberPlatformEnabled = platforms_enabled && platforms_enabled.indexOf("vib") > -1;

        if (this.state.user.user_fb_id) {
            if (facebook_platform_enabled) {
                await this.checkAdsManagementPermission(this.state.user.user_fb_id, this.state.user.user_fb_extended_token);
            }
        }

        let source = "";


        if (webpush_platform_enabled) {
            this.setState({
                webpush_platform_enabled: true
            });
        }
        if (viberPlatformEnabled) {
            this.setState({
                viberPlatformEnabled
            })
        }

        if (sources) {
            source = sources.filter(source =>
                source.id.toString() === selectedSource.toString())[0];
        }
        // if (!source && feeds_shared) {
        //     source = feeds_shared.filter(source =>
        //         source.project_id.toString() === selectedSource.toString())[0];
        // }

        if (this.state.selectedSource !== selectedSource) {
            this.setState({selectedSource})
        }

        await this.checkFbPageConnected()

        this.setState({loader: false})
        //console.log('campaigns: ', this.state.currentPlanLimitations)

    }

    componentDidUpdate = async () => {
        const postDataPassed = this.props.location.state ? this.props.location.state.post : '';
        if (postDataPassed !== this.state.postDataPassed) {
            this.setState({
                postDataPassed
            })
        }
        if (this.state.currentPlanLimitations !== this.props.currentPlanLimitations) {
            // console.log('facebook general didUpdate- plan limitations')

            await this.setState({
                currentPlanLimitations: this.props.currentPlanLimitations
            })
        }

        const {
            sources,
            //feeds_shared,
            selectedSource
        } = this.props;
        let platforms_enabled = this.props.platforms_enabled;
        let webpush_platform_enabled = platforms_enabled && platforms_enabled.indexOf("wp") > -1;
        let viberPlatformEnabled = platforms_enabled && platforms_enabled.indexOf("vib") > -1;


        let source = "";

        if (this.state.selectedSource !== selectedSource && this.state.selectedSource !== '') {
            if (this.state.fb_page_connected) {
                await this.setState({fb_page_connected: false})
                await this.checkFbPageConnected()
            } else {
                await this.checkFbPageConnected()
            }
        }


        if (!this.state.webpush_platform_enabled && webpush_platform_enabled) {
            this.setState({webpush_platform_enabled: true});
        } else if (this.state.webpush_platform_enabled && !webpush_platform_enabled) {
            this.setState({webpush_platform_enabled: false})
        }

        if (this.state.viberPlatformEnabled !== viberPlatformEnabled) {
            this.setState({viberPlatformEnabled})
        }

        // if (this.state.fb_page_connected && (!facebook_pages || !facebook_pages.data || !facebook_pages.data.length) &&
        //     (!facebook_pages_shared || !facebook_pages_shared.length)
        // ){
        //     this.setState({fb_page_connected: false})
        //
        // }

        if (sources) {
            source = sources.filter(source =>
                source.id.toString() === selectedSource.toString())[0];
        }
        // if (!source && feeds_shared) {
        //     source = feeds_shared.filter(source =>
        //         source.project_id.toString() === selectedSource.toString())[0];
        // }

        if (this.state.user !== this.props.user) {
            this.setState({
                user: this.props.user
            })
        }
    }

    checkFbPageConnected = async () => {
        if (this.state.fb_page_connected) {
            await this.setState({fb_page_connected: false})
        }
        const {selectedSource} = this.props;
        let facebook_pages = this.props.user.facebook_pages;
        let facebook_pages_shared = this.props.user.facebook_pages_shared;
        // console.log('facebook_pages: ',selectedSource, this.state.fb_page_connected, facebook_pages, facebook_pages_shared, facebook_pages_shared.length, !this.state.fb_page_connected)
        if (facebook_pages && facebook_pages.data && facebook_pages.data.length && !this.state.fb_page_connected) {
            await facebook_pages.data.map(async page => page.feed_id && page.feed_id.toString() === selectedSource.toString() && page.page_connected === 'Connected' ?
                await (this.setState({fb_page_connected: true, selectedSource}))
                : ''
            );
            if (facebook_pages_shared && facebook_pages_shared.length && !this.state.fb_page_connected) {
                await facebook_pages_shared.map(async page => page.project_id && page.project_id.toString() === selectedSource.toString() && page.connected ?
                    await (this.setState({fb_page_connected: true, selectedSource}))
                    : ''
                )
            }
        } else if (facebook_pages_shared && facebook_pages_shared.length && !this.state.fb_page_connected) {
            await facebook_pages_shared.map(async page => page.project_id && page.project_id.toString() === selectedSource.toString() && page.connected ?
                await (this.setState({fb_page_connected: true, selectedSource}))
                : ''
            )
        } else if (this.state.fb_page_connected) {
            this.setState({fb_page_connected: false, selectedSource})
        } else {
            this.setState({selectedSource})
        }
        if (this.state.loader) {
            await this.setState({loader: false})
        }
    }

    responseFacebook = async (response) => {
        // const user_id = await getCurrentUserId();
        // const resp = await http.get('api/user/' + user_id, { headers: { authorization: getJwt() } });
        const resp = await http.get('api/user_info', {headers: {authorization: getJwt()}});
        const user = await resp.data.data;
        await this.setState({
            user: user
        })
        try {
            // console.log('Facebook user id: ', response)
            this.checkAdsManagementPermission(response.id, response.accessToken)
            /* Get facebook accounts, returns each account Id and Name */
            if (this.state.fbAdsManagementPermission) {
                const fbAdAccounts = await axios.get(facebook_app_marketing_url + 'me/adaccounts?access_token=' + this.state.user.user_fb_extended_token + '&fields=name,owner,account_id,business_name');
                if (fbAdAccounts) {
                    await this.setState({
                        adAccounts: fbAdAccounts.data.data
                    })
                    if (!this.state.user.selectedAdAccount) {

                    }
                    this.selectAdAccount(fbAdAccounts.data.data[0])
                }
            }
        } catch (ex) {
            if (ex.response && ex.response.status === 404)
                this.setState({
                    errorMessage: ex.response.data.message
                })
            if (ex.response && ex.response.status === 401) {
                this.setState({
                    errorMessage: ex.response.data.message
                })
            }
        }
    }

    checkAdsManagementPermission = async (user_fb_id, user_fb_extended_token) => {
        if (user_fb_id && user_fb_extended_token) {
            try {
                const fbUserPermissions = await axios.get(facebook_app_graph_url + user_fb_id + '/permissions?access_token=' + user_fb_extended_token);
                // const fbAdsManagementPermission = await fbUserPermissions.data.data.find(item => item.permission === 'pages_manage_ads');
                const fbAdsManagementPermission = await fbUserPermissions.data.data.find(item => item.permission === 'ads_management');
                /* changed to 'ads_management' from from 'pages_manage_ads' */
                if (fbAdsManagementPermission) {
                    await this.setState({
                        fbAdsManagementPermission: (fbAdsManagementPermission.status === 'granted') ? true : false
                    })
                }
            } catch (ex) {
                if (ex.response && ex.response.status === 404)
                    this.setState({
                        errorMessage: ex.response.data.message
                    })
                if (ex.response && ex.response.status === 401) {
                    this.setState({
                        errorMessage: ex.response.data.message
                    })
                }
            }
        }
    }

    selectAdAccount = async (account) => {
        //console.log('A account...: ', account)
        if (account) {
            try {
                const result = await http.post('api/sponsored_facebook/user/' + getCurrentUserId() + '/adaccounts', {add_account_id: account.id}, {headers: {authorization: getJwt()}});
                if (result.data.account_selected) {
                    await this.setState({
                        selectedAdAccount: result.data.account_selected,
                        user: {
                            ...this.state.user,
                            add_account_id: result.data.account_selected
                        }
                    })
                }
            } catch (e) {
                //console.log('Evo ga error: ', e)
            }

        }
    }

    render() {
        const {
            sources
            //    , feeds_shared
        } = this.props;

        return (
            window.location.pathname === '/new' ?
                <React.Fragment>
                    <h1 className='main-title'>New Campaign</h1>
                    {sources.length
                        //|| feeds_shared.length
                        ?
                        this.state.loader ?
                            <div className='full-screen-loader'>
                                <img src="/img/chart-loader.svg" alt="Loading..."/>
                            </div>
                            :
                            <React.Fragment>
                                <h2 className='text-bold'>Select the type of message you would like to send.</h2>
                                {this.state.postDataPassed ?
                                    <p>You are going to create New Campaign for
                                        url: <strong>{this.state.postDataPassed.short_url}</strong>.
                                    </p>
                                    :
                                    ''
                                }

                                <div className="campaigns">

                                    <div className='campaign-card'
                                         onClick={() => this.props.history.push('/new/sms', {post: this.state.postDataPassed})}>
                                        <img alt='sms icon' src='/img/channels/sms-icon.svg'/>
                                        <div className="main-wrapper">
                                            <div className="campaign-title">SMS</div>
                                            <p className='campaign-desc'>Send text messages to your audience.</p>
                                        </div>
                                        {/*<img className='dollar-icon' src='/img/Dollar_icon.png'/>*/}
                                    </div>

                                    {this.state.viberPlatformEnabled ?
                                        <div className='campaign-card'
                                             onClick={() => this.props.history.push('/new/viber')}>
                                            <img alt='viber icon' src='/img/channels/viber-icon.svg'/>
                                            <div className="main-wrapper">
                                                <div className="campaign-title">
                                                    VIBER BUSINESS MESSAGE
                                                </div>
                                                <p className='campaign-desc'>Send targeted Viber messages to to phone
                                                    number
                                                    contacts.</p>
                                            </div>
                                            {/*<img className='dollar-icon' src='/img/Dollar_icon.png'/>*/}
                                        </div>
                                        :
                                        ''
                                    }

                                    {this.state.webpush_platform_enabled ?
                                        <div className='campaign-card'
                                             onClick={() => this.props.history.push('/new/web-push', {post: this.state.postDataPassed})}>
                                            <img alt='notification icon' src='/img/channels/notification-icon.svg'/>
                                            <div className="main-wrapper">
                                                <div className="campaign-title">Webpush</div>
                                                <p className='campaign-desc'>Send any URL as a Browser push notification
                                                    to
                                                    your
                                                    subscribers.</p>
                                            </div>
                                        </div>
                                        :
                                        ''
                                    }

                                    {
                                        this.state.platforms_enabled &&
                                        this.state.platforms_enabled.includes('fb') ?
                                            <React.Fragment>
                                                <div className='campaign-card'
                                                     onClick={() => this.props.history.push('/new/messenger', {post: this.state.postDataPassed})}>
                                                    <img alt='messenger-icon' src='/img/channels/messenger-icon.svg'/>
                                                    <div className="main-wrapper">
                                                        <div className="campaign-title">
                                                            SINGLE FACEBOOK MESSAGE
                                                        </div>
                                                        <p className='campaign-desc'>Send any URL (Link) you want., with
                                                            an
                                                            action
                                                            buttons</p>
                                                    </div>
                                                </div>
                                                <div className='campaign-card'
                                                     onClick={() => this.props.history.push('/new/messenger', {
                                                         post: this.state.postDataPassed,
                                                         type: 'carousel'
                                                     })}>
                                                    <img alt='messenger-icon' src='/img/channels/messenger-icon.svg'/>
                                                    <div className="main-wrapper">
                                                        <div className="campaign-title">
                                                            CAROUSEL FACEBOOK MESSAGE
                                                        </div>
                                                        <p className='campaign-desc'>Send multiple links with image and
                                                            button.</p>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                            : ''
                                    }
                                    {this.state.fb_page_connected ?
                                        <div className='campaign-card'
                                             onClick={() => this.props.history.push('/new/fb-campaigns', {post: this.state.postDataPassed})}>
                                            <img alt='messenger icon' src='/img/channels/messenger-icon.svg'/>
                                            <div className="main-wrapper">
                                                <div className="campaign-title">
                                                    FB MESSENGER SPONSORED MESSAGE
                                                </div>
                                                <p className='campaign-desc'>Send paid promotional messages to your FB
                                                    Messenger
                                                    subscribers.</p>
                                            </div>
                                            { /*<img className='dollar-icon' src='/img/Dollar_icon.png'/>*/}
                                        </div>
                                        :
                                        ''
                                    }
                                    {this.state.fb_page_connected ?
                                        <div className='campaign-card'
                                             onClick={() => this.props.history.push('/new/acquire-subscribers', {post: this.state.postDataPassed})}>
                                            <img alt='messenger icon' src='/img/channels/messenger-icon.svg'/>
                                            <div className="main-wrapper">
                                                <div className="campaign-title">
                                                    ACQUIRE SUBSCRIBERS
                                                </div>
                                                <p className='campaign-desc'>Run paid campaigns to acquire new FB
                                                    Messenger
                                                    subscribers</p>
                                            </div>
                                            { /*<img className='dollar-icon' src='/img/Dollar_icon.png'/>*/}
                                        </div>
                                        :
                                        ''
                                    }

                                </div>

                                <div className="campaigns">
                                    {
                                        this.state.platforms_enabled &&
                                        !this.state.platforms_enabled.includes('fb') ?
                                            <React.Fragment>
                                                <div className='campaign-card grey'
                                                     onClick={() => this.props.history.push('/channels')}>
                                                    <img alt='messenger-icon' src='/img/channels/messenger-icon-1.svg'/>
                                                    <div className="main-wrapper">
                                                        <div className="campaign-title">
                                                            SINGLE FACEBOOK MESSAGE
                                                        </div>
                                                        <p className='campaign-desc'>Send any URL (Link) you want., with
                                                            an
                                                            action
                                                            buttons</p>
                                                        <span>Enable this channel</span>

                                                    </div>
                                                </div>
                                                <div className='campaign-card grey'
                                                     onClick={() => this.props.history.push('/channels')}>
                                                    <img alt='messenger-icon' src='/img/channels/messenger-icon-1.svg'/>
                                                    <div className="main-wrapper">
                                                        <div className="campaign-title">
                                                            CAROUSEL FACEBOOK MESSAGE
                                                        </div>
                                                        <p className='campaign-desc'>Send multiple links with image and
                                                            button.</p>
                                                        <span>Enable this channel</span>

                                                    </div>
                                                </div>
                                            </React.Fragment>
                                            : ''
                                    }
                                    {!this.state.webpush_platform_enabled ?
                                        <div className='campaign-card grey'
                                             onClick={() => this.props.history.push('/channels')}>
                                            <img alt='notification icon' src=' /img/channels/notification-icon-1.svg'/>
                                            <div className="main-wrapper">
                                                <div className="campaign-title">Webpush</div>
                                                <p className='campaign-desc'>Send any URL as a Browser push notification
                                                    to
                                                    your
                                                    subscribers.</p>
                                                <span>Enable this channel</span>
                                            </div>
                                        </div>
                                        :
                                        ''
                                    }
                                    {!this.state.fb_page_connected ?
                                        <div className='campaign-card grey'
                                             onClick={() => this.props.history.push('/channels')}>
                                            <img alt='notification icon' src=' /img/channels/messenger-icon-1.svg'/>
                                            <div className="main-wrapper">
                                                <div className="campaign-title">
                                                    FB MESSENGER SPONSORED MESSAGE
                                                </div>
                                                <p className='campaign-desc'>Send paid promotional messages to your FB
                                                    Messenger
                                                    subscribers.</p>
                                                <span>Enable this channel</span>
                                            </div>
                                            { /*<img className='dollar-icon' src='/img/Dollar_icon.png'/>*/}
                                        </div>
                                        :
                                        ''
                                    }
                                    {!this.state.fb_page_connected ?
                                        <div className='campaign-card grey'
                                             onClick={() => this.props.history.push('/channels')}>
                                            <img alt='messenger-icon' src=' /img/channels/messenger-icon-1.svg'/>
                                            <div className="main-wrapper">
                                                <div className="campaign-title">
                                                    ACQUIRE SUBSCRIBERS
                                                </div>
                                                <p className='campaign-desc'>Run paid campaigns to acquire new FB
                                                    Messenger
                                                    subscribers</p>
                                                <span>Enable this channel</span>
                                            </div>
                                            { /*<img className='dollar-icon' src='/img/Dollar_icon.png'/>*/}
                                        </div>
                                        :
                                        ''
                                    }
                                    {!this.state.viberPlatformEnabled ?

                                        <div className='campaign-card grey'
                                             onClick={() => this.props.history.push('/channels')}>
                                            <img src='/img/channels/viber-icon-1.svg'/>
                                            <div className="main-wrapper">
                                                <div className="campaign-title">
                                                    VIBER BUSINESS MESSAGE
                                                </div>
                                                <p className='campaign-desc'>Send targeted Viber messages to to phone
                                                    number
                                                    contacts.</p>
                                                <span>Enable this channel</span>
                                            </div>
                                            {/*<img className='dollar-icon' src='/img/Dollar_icon.png'/>*/}
                                        </div>
                                        : ''}
                                </div>


                                <NewCampaignViberModal
                                    showModal={this.state.viberModalActive}
                                    handleClose={() => this.setState({viberModalActive: false})}
                                    maxWidth={500}
                                    history={this.props.history}
                                />
                                <NewCampaignSmsModal
                                    showModal={this.state.richTextModalActive}
                                    handleClose={() => this.setState({richTextModalActive: false})}
                                    maxWidth={500}
                                    history={this.props.history}
                                />
                            </React.Fragment> :

                        <NoFeeds userFullName={this.props.userFullName}/>


                    }
                    <div style={{height: 50}}/>
                </React.Fragment>
                :
                <Switch>
                    <Route
                        path='/new/sms'
                        render={(props) => <Sms
                            {...props}
                            user={this.props.user}
                            selectedSource={this.props.selectedSource}
                            selectedSourceNode={this.props.selectedSourceNode}
                            tags={this.props.tags}
                            plansData={this.props.plansData}
                            currentPlanLimitations={this.props.selectedSourceFull ? this.props.selectedSourceFull[0] ? this.props.selectedSourceFull[0].plan : '' : ''}
                            updateUserFromServer={this.props.updateUserFromServer}
                        />}
                    />

                    <Route path="/new/web-push"
                           render={(props) => <WebPushCustomPost
                               visible_post_reach_modal={this.props.visible_post_reach_modal}
                               tags={this.props.tags}
                               filterTags={this.props.filterTags}
                               loadingSubscribers={this.props.loadingSubscribers}
                               sources={sources}
                               history={this.props.history}
                               //feeds_shared={feeds_shared}
                               selectedSource={this.props.selectedSource}
                               checkAllPagesAndChannels={this.props.checkAllPagesAndChannels}
                               checkPagesAndChannels={this.props.checkPagesAndChannels}
                               checked_send_all={this.props.checked_send_all}
                               checked_channels={this.props.checked_channels}
                               addSource={this.props.addSource}
                               openModal={this.props.openModal}
                               user_facebook_pages={this.props.user_facebook_pages}
                               facebook_pages_shared={this.props.facebook_pages_shared}
                               platforms_enabled={this.props.platforms_enabled}
                               userFullName={this.props.userFullName}
                               currentPlanLimitations={this.props.currentPlanLimitations}
                               user={this.props.user}
                               {...props}/>
                           }/>

                    <Route path="/new/messenger"
                           render={(props) => <FacebookMessageCustomPost
                               visible_post_reach_modal={this.props.visible_post_reach_modal}
                               tags={this.props.tags}
                               filterTags={this.props.filterTags}
                               loadingSubscribers={this.props.loadingSubscribers}
                               sources={sources}
                               //feeds_shared={feeds_shared}
                               selectedSource={this.props.selectedSource}
                               checkAllPagesAndChannels={this.props.checkAllPagesAndChannels}
                               checkPagesAndChannels={this.props.checkPagesAndChannels}
                               checked_send_all={this.props.checked_send_all}
                               checked_channels={this.props.checked_channels}
                               addSource={this.props.addSource}
                               openModal={this.props.openModal}
                               user_facebook_pages={this.props.user_facebook_pages}
                               facebook_pages_shared={this.props.facebook_pages_shared}
                               platforms_enabled={this.props.platforms_enabled}
                               userFullName={this.props.userFullName}
                               user={this.props.user}
                               currentPlanLimitations={this.props.currentPlanLimitations}
                               updateUserFromServer={this.props.updateUserFromServer}
                               {...props}/>
                           }/>
                    <Route path="/new/fb-campaigns"
                           render={(props) => <FacebookSponsoredMessage

                               loadingSubscribers={this.props.loadingSubscribers}
                               sources={sources}
                               // feeds_shared={feeds_shared}
                               selectedSource={this.props.selectedSource}
                               addSource={this.props.addSource}
                               openModal={this.props.openModal}
                               user_facebook_pages={this.props.user_facebook_pages}
                               facebook_pages_shared={this.props.facebook_pages_shared}
                               platforms_enabled={this.props.platforms_enabled}
                               userFullName={this.props.userFullName}
                               {...props}/>
                           }/>
                    <Route path="/new/acquire-subscribers"
                           render={(props) => <AcquireSubscribers

                               loadingSubscribers={this.loadingSubscribers}
                               sources={sources}
                               //   feeds_shared={feeds_shared}
                               selectedSource={this.props.selectedSource}
                               checkAllPagesAndChannels={this.props.checkAllPagesAndChannels}
                               checkPagesAndChannels={this.props.checkPagesAndChannels}
                               checked_send_all={this.props.checked_send_all}
                               checked_channels={this.props.checked_channels}
                               addSource={this.props.addSource}
                               openModal={this.props.openModal}
                               user_facebook_pages={this.props.user_facebook_pages}
                               facebook_pages_shared={this.props.facebook_pages_shared}
                               platforms_enabled={this.props.platforms_enabled}
                               userFullName={this.props.userFullName}
                               {...props}/>
                           }/>
                    <Route
                        path='/new/sms'
                        render={(props) => <Sms
                            selectedSourceNode={this.props.selectedSourceNode}
                            {...props}
                            user={this.state.user}
                            selectedSource={this.props.selectedSource}
                            tags={this.props.tags}
                            plansData={this.props.plansData}
                            currentPlanLimitations={this.state.currentPlanLimitations}
                        />}
                    />

                    <Route
                        path='/new/viber'
                        render={(props) => <ViberBusinessMessage
                            {...props}
                            user={this.state.user}
                            selectedSource={this.props.selectedSource}
                            tags={this.props.tags}
                            plansData={this.props.plansData}
                            currentPlanLimitations={this.state.currentPlanLimitations}
                            updateUserFromServer={this.props.updateUserFromServer}
                            history={this.props.history}
                        />}
                    />
                </Switch>

        )
    }
}

export default Campaigns